import { atom } from 'recoil';

export const speechVoice = atom({
  key: 'speechVoice',
  default: {} as SpeechSynthesisVoice
});
